import { MutableEntityType } from 'app/agriculture/mutations/types/entityConfig';
import { useEntityQueryKey } from 'app/agriculture/queries/queryKey/useEntityQueryKey';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { getEntities } from 'app/agriculture/queries/entities/getEntities';

export function useEntities<T extends MutableEntityType>(entityType: T) {
    const getQueryKey = useEntityQueryKey<T>();
    const { data } = useSuspenseQuery(
        queryOptions({
            queryKey: getQueryKey(entityType),
            queryFn: getEntities,
        }),
    );

    return data;
}
